{
  "chat.greeting": "Hi there! I’m Clari, your 3DICOM Virtual Assistant.",
  "chat.lastConversation": "I’m here to help you navigate the 3DICOM platform, from uploading and sharing scans, exploring them in the viewer, or understanding storage options.",
  "chat.helpPrompt": "What would you like to do or learn more about?",
  "widget.title": "3DICOM - Chat with us",
  "widget.disclaimer": "<p>Do not enter Protected Health Information. This chatbot must not be used for diagnosis or treatment. AI responses may contain errors.</p><p>By using this chatbot you agree to its <a rel=\"noopener noreferrer nofollow\" class=\"text-primary underline cursor-pointer\" href=\"https://3dicomviewer.com/chatbot-terms-of-use/\" target=\"_blank\">Terms of Use</a>.</p>",
  "widget.menu.newChat": "Start a new chat",
  "widget.menu.endChat": "End chat",
  "widget.menu.recentChats": "View recent chats"
}
